/* eslint-disable no-useless-catch */
import { ACTIVE_STATUS, CHAIN_ENTITY_ROLE, serialize } from 'utils';

import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entities';

export const pathNameFindOne = '/entities/entity';

export const EntityApi = {
  createUser: async (body: any) => {
    try {
      const response = await entityService.post(`${pathname}/user`, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createUserForEmployee: async (body: any) => {
    try {
      const response = await entityService.post(
        `${pathname}/create-user-for-employee`,
        body
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  findUserPermissions: async () => {
    const url = `${pathname}/menu`;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  findFollowDomain: async (options: FindDomainOptions) => {
    let url = `${pathname}/follow-domain`;
    const query = serialize({ ...options });
    url += query;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  findEntityToCreateBill: async (option: any) => {
    let url = `${pathname}/find-to-create-bill`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findMembers: async (option: any, body: any) => {
    let url = `${pathname}/members`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findEntitiesForSyncProducts: async (
    option: FindEntitiesForSyncProductsType
  ) => {
    let url = `${pathname}/find-entities-for-sync-products`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findCustomerEntitiesForSyncProductsOptimize: async (
    option: FindEntitiesForSyncProductsType
  ) => {
    let url = `${pathname}/find-customer-entities-for-sync-products-optimize`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneForSelect: async (id: string) => {
    const url = `${pathname}/entity-with-central/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findEntityToConnect: async (option: FindEntityToConnectOption) => {
    let url = `${pathname}/entity-to-connect`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findChainEntities: async (centralEntityID: string, option: FindOptions) => {
    let url = `${pathname}/${centralEntityID}/chain-entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findChainSuppliers: async (options: { supplierName: string }) => {
    let url = `${pathname}/find-chain-suppliers`;
    const query = serialize(options);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithAuth: async (option: FindWithAuthOption) => {
    let url = `${pathname}/auth`;
    const query = serialize(option.query);
    url += query;

    try {
      const response = await entityService.post(url, option.body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithAuthEntityInChain: async (
    entityID: string,
    option?: FindWithAuthEntityInChainOption
  ) => {
    let url = `${pathname}/entities-in-chain/${entityID}`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findDefaultGroupAndPolicyForCreatePartner: async (
    option?: FindDefaultGroupAndPolicyForCreatePartnerOption
  ) => {
    let url = `${pathname}/find-default-group-policy-for-create-partner`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(`${pathname}/entity`, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createCustomDomain: async (body: any) => {
    try {
      const response = await entityService.post(
        `${pathname}/custom-domain`,
        body
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createAnonymous: async (body: any) => {
    try {
      const response = await entityService.post(
        `${pathname}/anonymous-entity`,
        body
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  findOneWithAuth: async (id: string, options: FindOneOptions) => {
    let url = `${pathname}/auth/${id}`;
    const query = serialize({
      ...options,
      where: { ...options.where, status: ACTIVE_STATUS.ACTIVATED },
    });
    url += query;

    const response = await entityService.get(url);

    try {
      return response;
    } catch (error) {
      throw error;
    }
  },

  findOverviewCertificationsInfo: async id => {
    const url = `${pathNameFindOne}/find-overview-certifications-info/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findContactInfo: async id => {
    const url = `${pathNameFindOne}/find-contact-info/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findSeoInfo: async id => {
    const url = `${pathNameFindOne}/find-seo/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findForWebsiteInfo: async id => {
    const url = `${pathNameFindOne}/find-for-website-info/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findCatalogForWebsiteInfo: async id => {
    const url = `${pathNameFindOne}/find-catalog-for-website-info/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOverviewInfo: async id => {
    const url = `${pathNameFindOne}/find-overview-info/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string, option: FindOneOptions | undefined) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneUser: async (id: string) => {
    const url = `${pathname}/find-user/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  verifyDiary: async () => {
    const url = `${pathname}/verify-diary`;

    try {
      return await entityService.patch(url);
    } catch (error) {
      throw error;
    }
  },

  updateShareKey: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/forecast-share-key`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateCheckShareKey: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/is-forecast-share-key-activated`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updatePassword: async (body: UpdatePasswordBody) => {
    try {
      return await entityService.patch(`${pathname}/password`, body);
    } catch (error) {
      throw error;
    }
  },

  updateTheme: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/theme`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateThemeFrames: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/theme-frames`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateSEO: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/seo`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateContact: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/contact`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateEntityInfo: async (id: string, body: EntityInfo) => {
    try {
      return await entityService.patch(`${pathname}/${id}`, body);
    } catch (error) {
      throw error;
    }
  },

  findToCheckPhoneNumberExist: async (
    options: { phoneNumber: string },
    activated = true
  ) => {
    let url = `${pathname}/check-phone-number-exist`;
    let query = serialize({ ...options });
    if (activated) {
      query = serialize({
        ...options,
        where: { status: ACTIVE_STATUS.ACTIVATED },
      });
    }
    url += query;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  findToCheckVerifiedEmailExist: async (options: { email: string }) => {
    let url = `${pathname}/check-email-exist`;
    const query = serialize({ ...options });
    url += query;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  checkDuplicateCouponCode: async (option?: any) => {
    let url = `${pathname}/check-duplicate-coupon`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findBillCollaborators: async () => {
    const url = `${pathname}/bill-collaborators`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findBillCustomers: async (
    options: FindBillCustomersOption,
    body: FindBillCustomersBody
  ) => {
    let url = `${pathname}/bill-customers`;
    const query = serialize(options || {});
    url += query;
    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  removeEntityProposalPolicy: async (id: string) => {
    const url = `${pathname}/${id}/remove-entity-proposal-policy`;

    try {
      const response = await entityService.patch(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findEnterpriseInfoUser: async () => {
    const url = `${pathname}/find-enterprise-info-user`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateEnterpriseInfoUser: async (body: UpdateEnterpriseInfoUserBody) => {
    const url = `${pathname}/update-enterprise-info-user`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findEntityInfoForConfirmConnect: async (id: string) => {
    const url = `${pathname}/find-entity-info-for-confirm-connect/${id}`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  suggestEntityToConnect: async (option: SuggestEntityToConnectOption) => {
    let url = `${pathname}/suggest-entity-to-connect`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  searchEntityToConnect: async (option: SearchEntityToConnectOption) => {
    let url = `${pathname}/search-entity-to-connect`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicateDomain: async (option: CheckEntityDomainExistedOption) => {
    let url = `${pathname}/check-duplicate-domain`;

    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findToShareDigitalMenuShareFromMenu: async (
    digitalMenuID: string,
    options: { name: string }
  ) => {
    let url = `${pathname}/digital-menu/${digitalMenuID}/find-entity-to-share`;
    const query = serialize({ ...options });
    url += query;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  getDashboardStats: async (
    id: string,
    options?: { startDate?: string; endDate?: string }
  ) => {
    let url = `${pathname}/${id}/dashboard`;
    if (options) {
      const query = serialize({ ...options });
      url += query;
    }

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface UpdatePasswordBody {
  oldPassword: string;
  newPassword: string;

  // info to verify account
  phoneNumber?: string;
  email?: string;
  accountOtpTrackingID: string;
}

export interface EntityInfo {
  id?: string;
  locationID?: string;
  userID?: string;
  code?: string;
  fullName?: string;
  displayName?: string;
  description?: string;
  email?: string;
  phoneNumber?: string;
  website?: string;
  address?: string;
  latitude?: string;
  longitude?: string;
  avatar?: string;
  isCentral?: boolean;
  displayAbsoluteQuantity?: boolean;
}

export interface EntityInitInfo {
  avatar: string;
  banner: string;
  avgRating?: number;
  centralEntityID?: string | null;
  chainEntityIDs: string[];
  chainEntityRole: CHAIN_ENTITY_ROLE;
  /**
   * Khi thực thể là trung tâm hoặc thực thể không nằm trong chuỗi = true ngoăc lại = false
   */
  canUpdateDelete: boolean;
  /**
   * Khi thực thể là trung tâm hoặc thực thể là nhà cung cấp của trung tâm hoặc thực thể không nằm trong chuỗi = true ngoăc lại = false
   */
  canCreateNewMaterial: boolean;
  canCreateNewProduct: boolean;
  displayAbsoluteQuantity: boolean;
  displayName: string;
  domain?: string | null;
  domainStatus?: number;
  email?: string;
  isForecastShareKeyActivated?: boolean;
  forecastShareKey?: string;
  id: string;
  isCentral?: boolean;
  isDiaryVerified?: boolean;
  allowsChangePricePolicyForCollaborator?: boolean;
  ownerID: string;
  phoneNumber?: string;
  shortID?: string;
  wardID?: string;
  objectType?: number;
  totalEntityArea?: number;
  totalProductionPlan?: number;
  totalBranch?: number;
  totalCampaign?: number;
  totalCoBuy?: number;
  totalCombo?: number;
  totalCoupon?: number;
  totalDigitalMenu?: number;
  totalEmployee?: number;
  totalFarmingEntityProductObject?: number;
  totalFieldEntityProductObject?: number;
  totalProductionEntityProductObject?: number;
  totalPartner?: number;
  totalPrice?: number;
  totalEntityProcess?: number;
  totalProduct?: number;
  totalReceivedPrice?: number;
  totalUsedPrice?: number;
  totalWikiFile?: number;
  totalWikiImage?: number;
  type: number;
  website?: string | null;
  role: string;
  slug?: string;
  entityOptions?: any;
  owner: {
    id: string;
    avatar: string;
    email: string;
    phoneNumber: string;
    displayName: string;
    totalFarmAccount: number;
    totalCollaboratorAccount: number;
    totalStoreAccount: number;
  };
  additionalInfo?: any;
}

export interface FindEntityToConnectOption {
  entityID: string;
  typeInChain?: number;
  actionRole?: number;
  name?: string;
  take?: number;
  isInChain?: boolean;
  entityType?: number;
}

export interface SuggestEntityToConnectOption {
  entityID: string;
  typeInChain?: number;
  actionRole?: number;
  isInChain?: boolean;
  entityType?: number;
}

export interface SearchEntityToConnectOption {
  entityID: string;
  name: string;
  isEntityCode: boolean;
  page: number;
  take: number;
  typeInChain?: number;
  actionRole?: number;
  isInChain?: boolean;
  entityType?: number;
}

export interface CheckEntityDomainExistedOption {
  domain: string;
}

export interface FindWithAuthEntityInChainOption {
  role?: number;
}

export interface FindDefaultGroupAndPolicyForCreatePartnerOption {
  entityID: string;
  groupType: number;
  chainEntityID?: string;
}

export interface FindWithAuthOption {
  query?: {
    page?: number;
    take?: number;
    type?: number;
    name?: string;
  };
  body?: {
    entityOptionIDs?: string[];
  };
}

export type FindEntitiesForSyncProductsType = {
  page: number;
  take: number;
  type?: string;
  optionID?: string;
  name?: string;
  role: number;
};

export interface FindBillCustomersOption {
  isCustomer: boolean;
  isCollaborator: boolean;
  collaboratorID: string;
  supplierID?: string;
}

export interface FindBillCustomersBody {
  paymentStatuses?: number[];
}

export interface EntityWithAuth {
  adminDomain: string;
  id: string;
  type: number;
  avatar: string;
  status: number;
  role: string;
  displayName: string;
  domain: string;
  domainStatus: string;
  code: string;
  createdAt: string;
  email: string;
  entityOptions: any[];
  forecastShareKey: string;
  fullName: string;
  groups: any[];
  isCentral: boolean;
  isOpenNewTab: boolean;
  owner: any;
  slug: string;
  website: string;
  employeeStatus: number | null;
}

export interface SelectedEntityDomain {
  id: string;
  type: number;
  status: number;
  role: string;
  isOpenNewTab: string;
  adminDomain: string;
  domainStatus: string;
  employeeStatus: number | null;
  isSkipCheckAccess: boolean;
}

export interface FindDomainOptions {
  domain: string;
  appType: number;
}

export interface UpdateEnterpriseInfoUserBody {
  name?: string;
  phoneNumber?: string;
  email?: string;
  enterpriseIdentificationNumber?: string;
  address?: string;
  wardCode?: string;
  districtCode?: string;
  provinceCode?: string;
  youtubeURL?: string;
  linkedinURL?: string;
  facebookURL?: string;
}

export interface PermissionType {
  key: string;
  parentKey: string;
  value: boolean;
}
